//removeIf(production)
const FluidMeter = require('../../external/fluid-meter/fluid-meter.min.js');
//endRemoveIf(production)

class ClaroluzProgressIndicator {
    target: HTMLElement;
    options: object
    private fm: any

    constructor(target: HTMLElement, options: object) {
        this.target = target;
        this.options = options;
        
        this.fm = new FluidMeter();
        this.fm.init({
            targetContainer: this.target,
            fillPercentage: 0,
            options: this.options
        });
    }

    public updateProgress(percentage: number) {
        this.fm.setPercentage(percentage);
    }
}

//removeIf(production)
export default ClaroluzProgressIndicator;
//endRemoveIf(production)